import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Navigate, Outlet, useMatch } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import AccountHeader from '@/components/pageheaders/AccountHeader';
import FleetHeader from '@/components/pageheaders/FleetHeader';
import FleetUnitHeader from '@/components/pageheaders/FleetUnitHeader';
import UnitHeader from '@/components/pageheaders/UnitHeader';
import { allUnitsQueryOptions } from '@/service/vpc/queryOptions';

export const Route = createFileRoute('/_authenticated/_account')({
  component: AccountLayout,
  errorComponent: ErrorBoundary,
});

function AccountLayout() {
  const { data: allUnits, isFetched, isLoading } = useQuery(allUnitsQueryOptions());

  const matchAccount = useMatch({
    from: '/_authenticated/_account',
    shouldThrow: false,
  });

  const matchMembersById = useMatch({
    from: '/_authenticated/_account/members/$endUserId/',
    shouldThrow: false,
  });

  const matchFleet = useMatch({
    from: '/_authenticated/_account/fleets/$fleetId',
    shouldThrow: false,
  });

  const matchFleetUnit = useMatch({
    from: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId',
    shouldThrow: false,
  });

  const matchFleetMaintenanceProtocol = useMatch({
    from: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey/',
    shouldThrow: false,
  });

  const matchUnit = useMatch({
    from: '/_authenticated/_account/units/$endCustomerUnitId',
    shouldThrow: false,
  });

  const matchMaintenanceProtocol = useMatch({
    from: '/_authenticated/_account/units/$endCustomerUnitId/maintenance/$protocolKey/',
    shouldThrow: false,
  });

  if (isLoading || !isFetched) {
    return <></>;
  }

  //   User with no units -> Welcome message
  if (allUnits && allUnits.length == 0) {
    return <Navigate to="/welcome" search={(prev) => ({ ...prev })} replace />;
  }

  return (
    <>
      {matchFleetMaintenanceProtocol || matchMaintenanceProtocol || matchMembersById ? (
        <></>
      ) : matchUnit ? (
        <UnitHeader />
      ) : matchFleetUnit ? (
        <FleetUnitHeader />
      ) : matchFleet ? (
        <FleetHeader />
      ) : matchAccount ? (
        <AccountHeader />
      ) : null}
      <Outlet />
    </>
  );
}
